<template>
  <v-app>
    <template>
      <!-- Conditionally render Header -->
      <template v-if="!is404">
        <HeaderMenu :storyblokVersion="storyblokVersion" />
      </template>

      <!-- Page content -->
      <router-view />

      <!-- Conditionally render footer -->
      <template>
        <FooterSection v-if="showFooter" />
      </template>

      <!-- Cookie banner -->
      <template v-if="!is404">
        <vue-cookie-accept-decline
          :debug="false"
          :disableDecline="false"
          :showPostponeButton="false"
          @clicked-accept="cookieClickedAccept"
          @clicked-decline="cookieClickedDecline"
          @clicked-postpone="false"
          @removed-cookie="false"
          @status="cookieStatus"
          elementId="cookieBanner"
          position="bottom"
          ref="cookieBanner"
          transitionName="slideFromBottom"
          type="bar"
        >
          <!-- Optional -->
          <template #postponeContent>&times;</template>

          <!-- Optional -->
          <template #message>
            Für ein optimales Website-Erlebnis nutzen wir Cookies und ähnliche
            Technologien. Ein Klick auf "Alle Akzeptieren" erlaubt uns die
            Datenverarbeitung. Natürlich können Sie Ihre Zustimmung jederzeit
            widerrufen.
            <a href="https://www.anni.care/datenschutz/" target="_blank"
              >Nähere Informationen</a
            >
          </template>

          <!-- Optional -->
          <template #declineContent>Nur funktionale Cookies</template>

          <!-- Optional -->
          <template #acceptContent>Alle akzeptieren</template>
        </vue-cookie-accept-decline>
      </template>
    </template>
  </v-app>
</template>

<script>
import FooterSection from "./components/LandingPage/Footer.vue";
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
import HeaderMenu from "./components/HeaderMenu/HeaderMenu.vue";

export default {
  components: {
    FooterSection,
    VueCookieAcceptDecline,
    HeaderMenu,
  },
  data() {
    return {
      isMapView: false,
      cookieboxShow: false,
      storyblokVersion:
        process.env.NODE_ENV !== "production" ? "draft" : "published",
      is404: false,
    };
  },
  methods: {
    isMobile() {
      return window.innerWidth <= 650;
    },
    cookieClickedAccept() {
      if (this.$route.name !== "Rollatoren" && window.SibConversations) {
        window.SibConversations("show");
      }
      this.$gtag?.optIn();
    },
    cookieClickedDecline() {
      if (this.$route.name !== "Rollatoren" && window.SibConversations) {
        window.SibConversations("show");
      }
    },
    cookieStatus(currentStatus) {
      if (currentStatus === "accept") {
        this.$gtag?.optIn();
      } else if (!currentStatus) {
        this.cookieboxShow = true;
      }
    },
  },
  mounted() {
    if (this.$route.name === "PageNotFound") {
      this.is404 = true;
      document.title = "404 - Seite nicht gefunden | anni.care";
    }

    // show special header when sani exclusive flow is launched
    if (this.cookieboxShow && window.SibConversations)
      window.SibConversations("hide");
  },
  watch: {
    // watch route changes
    $route(to) {
      if (to.name === "AnbieterMapApp") {
        this.isMapView = true;
      } else if (to.name === "PageNotFound") {
        this.is404 = true;
        document.title = "404 - Seite nicht gefunden | anni.care";
      }
    },
  },
  computed: {
    showFooter() {
      return !this.is404 && (this.isMapView ? this.isMobile() === false : true);
    },
  },
};
</script>
